import { Modal } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmationModal = ({ onConfirm, onCancel }: Props) => {
  return (
    <Modal.Root onPressOutside={() => {}}>
      <Modal.Header title="Are you sure?" />
      <Modal.Content>
        <Text>You will lose all changes.</Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="tertiary" onPress={onCancel}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={onConfirm}>Confirm</Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
